<template>
  <div class="header-box">
    <div class="header">
      <span class="colorspan"
        ><img width="16" src="@/assets/channel/2.png" alt="" />{{
          titleName
        }}</span
      >
    </div>
    <div class="table-content">
      <table border="1">
        <tr>
          <th >评估项目</th>
          <th >评估内容</th>
          <!-- <th>评估方式</th> -->
          <th  v-if="userTypeValue !== 'expert'">自评</th>
          <th  v-if="userTypeValue == 'expert'">专家评分</th>
          <th
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            市级评分
          </th>
          <th style="display: none">省级评分</th>
        </tr>
        <tr>
          <th rowspan="3" >
            组织制度建设（15分）
            <p
              v-if="userTypeValue == 'cityAdm' || 
              userTypeValue == 'expert'  || 
              (userTypeValue == 'declarator'&&saveStatus==1)
              "
              style="color: #1890ff; cursor: pointer"
              @click="preview(1)"
            >
              查看附件：
              {{ dataInfo.fileName1 }}
            </p>
          </th>
          <th style="width: 158px">
            1.单位将贯彻落实《江苏省社会科学普及促进条例》工作纳入其发展规划和工作计划并进行统一部署；有社科普及工作年度计划、具体项目和活动总结；将社科普及工作纳入有关绩效考核和评比，有比较完善的激励机制。
            （5分）
          </th>
          <!-- <th rowspan="3">查阅有关文件、记录、资料等</th> -->
          
          <td colspan="1">
            <!-- 专家评审时隐藏 -->
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center; height: 85px"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm'  "
              v-model="myRateList[0]"
              max="5"
              min="0"
              @input="restrictionFn(0, 5, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[0]"
              max="5"
              min="0"
              @input="restrictionFn(0, 5, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              type="number"
              style="text-align: center; height: 85px"
              v-model="cityRateList[0]"
              max="5"
              min="0"
              @input="restrictionFn(0, 5, 1)"
            />
          </td>
          <!-- <td colspan="1" style="display: none">
            <input
              type="number"
              style="text-align: center; height: 85px"
              v-model="provincialRateList[0]"
              max="5"
              min="0"
              @input="restrictionFn(0, 5, 2)"
            />
          </td> -->
        </tr>
        <tr>
          <th>
            2.单位主要领导重视社科普及，积极支持开展社科普及活动；明确有领导分管社科普及工作，有专人协调负责科普教育基地建设并与省、市社科联保持密切联系。
            （5分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              style="text-align: center"
              v-model="myRateList[1]"
              max="5"
              min="0"
              @input="restrictionFn(1, 5, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[1]"
              max="5"
              min="0"
              @input="restrictionFn(1, 5, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[1]"
              max="5"
              min="0"
              @input="restrictionFn(1, 5, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[1]"
              max="5"
              min="0"
              @input="restrictionFn(1, 5, 2)"
            />
          </td>
        </tr>
        <tr>
          <th>
            3.所在单位每年能够安排必要的经费用于社科普及工作与活动；建立社科普及工作档案，开展社科普及活动有文字记载、照片或影像等资料以及公众参与人数等统计数据。
            （5分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[2]"
              max="5"
              min="0"
              @input="restrictionFn(2, 5, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[2]"
              max="5"
              min="0"
              @input="restrictionFn(2, 5, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[2]"
              max="5"
              min="0"
              @input="restrictionFn(2, 5, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[2]"
              max="5"
              min="0"
              @input="restrictionFn(2, 5, 2)"
            />
          </td>
        </tr>
        <tr>
          <th rowspan="2">
            队伍建设（15分）
            <p
              v-if="userTypeValue == 'cityAdm'  || 
              userTypeValue == 'expert'  || 
              (userTypeValue == 'declarator'&&saveStatus==1)"
              style="color: #1890ff; cursor: pointer"
              @click="preview(2)"
            >
              查看附件：
              {{ dataInfo.fileName2 }}
            </p>
          </th>
          <th style="width: 158px">
            4.拥有一支由人文社会科学教学和研究人员、社科普及工作者组成的社科普及工作队伍。
            （10分）
          </th>
          <!-- <th rowspan="2">查阅有关记录、资料等</th> -->
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[3]"
              max="10"
              min="0"
              @input="restrictionFn(3, 10, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[3]"
              max="10"
              min="0"
              @input="restrictionFn(3, 10, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[3]"
              max="10"
              min="0"
              @input="restrictionFn(3, 10, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[3]"
              max="10"
              min="0"
              @input="restrictionFn(3, 10, 2)"
            />
          </td>
        </tr>
        <tr>
          <th>
            5.加强社科普及志愿服务队伍建设，志愿者队伍人员稳定，定期组织开展普及宣传活动。
            （5分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[4]"
              max="5"
              min="0"
              @input="restrictionFn(4, 5, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[4]"
              max="5"
              min="0"
              @input="restrictionFn(4, 5, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[4]"
              max="5"
              min="0"
              @input="restrictionFn(4, 5, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[4]"
              max="5"
              min="0"
              @input="restrictionFn(4, 5, 2)"
            />
          </td>
        </tr>

        <tr>
          <th rowspan="2">
            载体建设（20分）
            <p
              v-if="userTypeValue == 'cityAdm'  || 
              userTypeValue == 'expert' || 
              (userTypeValue == 'declarator'&&saveStatus==1)
              "
              style="color: #1890ff; cursor: pointer"
              @click="preview(3)"
            >
              查看附件：
              {{ dataInfo.fileName3 }}
            </p>
          </th>
          <th style="width: 158px">
            6.有相对固定的社科普及活动场所（面积≥100平方米）、社科普及宣传资料；以橱窗、展板、固定宣传栏、电子屏幕等为载体长期开展普及宣传。
            （10分）
          </th>
          <!-- <th rowspan="2">实地实物查看</th> -->
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[5]"
              max="10"
              min="0"
              @input="restrictionFn(5, 10, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[5]"
              max="10"
              min="0"
              @input="restrictionFn(5, 10, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[5]"
              max="10"
              min="0"
              @input="restrictionFn(5, 10, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[5]"
              max="10"
              min="0"
              @input="restrictionFn(5, 10, 2)"
            />
          </td>
        </tr>
        <tr>
          <th>
            7.创办展示社科普及内容的网站或网页、微信、微博、微视频、移动客户端，运用新媒体开展社科普及宣传。
            （10分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
            v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[6]"
              max="10"
              min="0"
              @input="restrictionFn(6, 10, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[6]"
              max="10"
              min="0"
              @input="restrictionFn(6, 10, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[6]"
              max="10"
              min="0"
              @input="restrictionFn(6, 10, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[6]"
              max="10"
              min="0"
              @input="restrictionFn(6, 10, 2)"
            />
          </td>
        </tr>
        <tr>
          <th rowspan="3">
            活动开展（35分 ）
            <p
              v-if="userTypeValue == 'cityAdm'  || 
              userTypeValue == 'expert'|| 
              (userTypeValue == 'declarator'&&saveStatus==1)
              "
              style="color: #1890ff; cursor: pointer"
              @click="preview(4)"
            >
              查看附件：
              {{ dataInfo.fileName4 }}
            </p>
          </th>
          <th style="width: 158px">
            8.参与全省社科普及宣传周，组织开展社科普及文艺演出、广场咨询、宣传展览等活动，并在活动期间对公众免费或优惠开放，每项5分，3年累计不超过15分
            （15分）
          </th>
          <!-- <th rowspan="3">查阅有关资料</th> -->
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[7]"
              max="15"
              min="0"
              @input="restrictionFn(7, 15, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[7]"
              max="15"
              min="0"
              @input="restrictionFn(7, 15, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[7]"
              max="15"
              min="0"
              @input="restrictionFn(7, 15, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[7]"
              max="15"
              min="0"
              @input="restrictionFn(7, 15, 2)"
            />
          </td>
        </tr>
        <tr>
          <th>
            9.社科普及工作人员或活动项目获得省市表扬或者获得省市普及项目资助，每项4分，3年累计不超过10分。
            （10分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[8]"
              max="10"
              min="0"
              @input="restrictionFn(8, 10, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[8]"
              max="10"
              min="0"
              @input="restrictionFn(8, 10, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[8]"
              max="10"
              min="0"
              @input="restrictionFn(8, 10, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[8]"
              max="10"
              min="0"
              @input="restrictionFn(8, 10, 2)"
            />
          </td>
        </tr>
        <tr>
          <th>
            10.编印、出版主题社科普及类读物、宣传册（挂图）、音像等资料，制作发放社科普及宣传产品，每项4分，3年累计不超过10分。（10分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[9]"
              max="10"
              min="0"
              @input="restrictionFn(9, 10, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[9]"
              max="10"
              min="0"
              @input="restrictionFn(9, 10, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[9]"
              max="10"
              min="0"
              @input="restrictionFn(9, 10, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[9]"
              max="10"
              min="0"
              @input="restrictionFn(9, 10, 2)"
            />
          </td>
        </tr>

        <tr>
          <th rowspan="2">
            社会影响（15分）
            <p
              v-if="userTypeValue == 'cityAdm'  || 
              userTypeValue == 'expert' ||
              (userTypeValue == 'declarator'&&saveStatus==1)
              "
              style="color: #1890ff; cursor: pointer"
              @click="preview(5)"
            >
              查看附件：
              {{ dataInfo.fileName5 }}
            </p>
          </th>
          <th style="width: 158px">
            11.社科普及活动覆盖范围：跨单位合作加2分，跨地区合作加4分。 （6分）
          </th>
          <!-- <th rowspan="2">查阅有关资料</th> -->
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[10]"
              max="6"
              min="0"
              @input="restrictionFn(10, 6, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[10]"
              max="6"
              min="0"
              @input="restrictionFn(10, 6, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[10]"
              max="6"
              min="0"
              @input="restrictionFn(10, 6, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              style="text-align: center"
              type="number"
              v-model="provincialRateList[10]"
              max="6"
              min="0"
              @input="restrictionFn(10, 6, 2)"
            />
          </td>
        </tr>
        <tr>
          <th>
            12.社科普及相关宣传报道：中央媒体及网站、客户端等3分；省级媒体及网站、客户端等自媒体2分；市县媒体及内刊、网站、客户端等1分。
            （9分）
          </th>
          <!-- 专家评审时隐藏 -->
          <td colspan="1">
            <input v-if="userTypeValue !== 'expert'"
              style="text-align: center"
              type="number"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              v-model="myRateList[11]"
              max="9"
              min="0"
              @input="restrictionFn(11, 9, 0)"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue === 'expert'"
              style="text-align: center; height: 85px;background-color: white;"
              type="number"
              v-model="expertRateList[11]"
              max="9"
              min="0"
              @input="restrictionFn(11, 9, 3)"
            />
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="number"
              v-model="cityRateList[11]"
              max="9"
              min="0"
              @input="restrictionFn(11, 9, 1)"
            />
          </td>
          <td colspan="1" style="display: none">
            <input
              type="number"
              style="text-align: center"
              v-model="provincialRateList[11]"
              max="9"
              min="0"
              @input="restrictionFn(11, 9, 2)"
            />
          </td>
        </tr>

        <tr>
          <th colspan="2">合计得分</th>
          <td colspan="1">
            <input
              v-if="userTypeValue !== 'expert'"
              type="text"
              style="text-align: center"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              
              v-model="MySum"
            />
            <!-- 专家评审时显示 -->
            <input
              v-if="userTypeValue == 'expert'"
              type="text"
              style="text-align: center"
              :disabled="toTarget == 'cityAdm' || toTarget == 'declarator' || toTarget == 'provinceAdm' "
              
              v-model="ExpertSum"
            />
            <!-- readonly="readonly" -->
          </td>
          <td
            colspan="1"
            v-if="
              toTarget == 'cityAdm' ||
              toTarget == 'declarator' ||
              toTarget == 'provinceAdm'
            "
          >
            <input
              style="text-align: center"
              type="text"
              readonly="readonly"
              v-model="citySum"
            />
          </td>
          <td colspan="1" style="display: none">
            <input type="text" readonly="readonly" v-model="provincialSum" />
          </td>
        </tr>
      </table>
    </div>
    <!-- <a-spin :spinning="spinning" tip="上传中">
      <div class="upload">
        资料
        <a-upload
          :customRequest="uploaderCoverUrlOne"
          :show-upload-list="false"
          accept=".rar, .zip"
        >
          <a-button style="margin-top: 10px">
            <a-icon type="upload" />本地上传
          </a-button>
        </a-upload>
        <span style="margin-left: 10px">请上传.rar、.zip格式的压缩包</span>
        <div v-if="fileName" class="file">
          <p>{{ fileName }}</p>
          <a-icon type="close" @click="removeFile" />
        </div>
      </div>
    </a-spin> -->

    <!-- <div class="radio">
      <p>省级意见：</p>
      <a-radio-group v-model="dataInfo.provincialOpinion" name="radioGroup">
        <a-radio value="0">优秀</a-radio>
        <a-radio value="1">合格</a-radio>
        <a-radio value="2">不合格</a-radio>
      </a-radio-group>
    </div> -->
    <div class="footer">
      <a-button
        type="primary"
        @click="save(0)"
        v-if="
          saveStatus == 0 ||
          declareStatus == 0 ||
          declareStatus == 2 

        "
        >保存草稿</a-button
      >
      <!-- <a-button
        type="primary"提交
        @click="save(1)"
        v-if="saveStatus == 0 || declareStatus == 0"
        >提交</a-button
      > -->
      <!-- 市级保存按钮 -->
      <!-- <a-button
        type="primary"
        @click="save(1)"
        v-if="userTypeValue == 'cityAdm'"
        >提交</a-button
      > -->
      <!-- <a-button
        type="primary"
        @click="save(1)"
        v-if="
          (saveStatus == 1 && declareStatus != 1) ||
          (saveStatus == 1 && userTypeValue == 'cityAdm') ||
          declareStatus == 0 ||
          declareStatus == 2 ||
          declareStatus == 3 ||
          declareStatus == 5 ||
          userTypeValue == 'expert'
        "
        >提交</a-button
      > -->
      <a-button
        type="primary"
        @click="save(1)"
        v-if="
          (saveStatus == 1 && declareStatus != 1) ||
          (saveStatus == 1 && userTypeValue == 'cityAdm') ||
          declareStatus == 0 ||
          declareStatus == 2 ||
          declareStatus == 3 ||
          declareStatus == 5 

        "
        >提交</a-button
      >
      <a-button @click="goBack">上一页</a-button>
      <a-button @click="cancel">返回</a-button>

    </div>
  </div>
</template>

<script>
import {
  createdecInformationApi,
  updateDecInformationApi,
  decUserAccessUpdateApi,
  decInformationMyListApi,
  openUploadApi,
} from "@/api/declare";
export default {
  props: {
    chooseType: {
      type: Number,
      default: 0,
    },
    toTarget: {
      type: String,
    },
  },
  data() {
    return {
      saveStatus: 0,
      declareStatus: 0,
      userTypeValue: "",
      fileName: "",
      spinning: false,
      titleName: "江苏省社科普及示范基地评估表",
      newDataInfo: {},
      dataInfo: {
        myTotal: "",
        expertTotal:"",
        cityTotal: "",
        provincialTotal: "",
        fileName1: "",
        fileUrl1: "",
        fileName2: "",
        fileUrl2: "",
        fileName3: "",
        fileUrl3: "",
        fileName4: "",
        fileUrl4: "",
        fileName5: "",
        fileUrl5: "",
      },
      myRateList: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      expertRateList:[
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      cityRateList: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      provincialRateList: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    };
  },
  computed: {
    provincialSum() {
      let sum = 0;
      for (let i = 0; i < 22; i++) {
        sum = sum + Number(this.provincialRateList[i]);
      }
      this.dataInfo.provincialTotal = sum;
      return sum;
    },
    MySum() {
      let sum = 0;
      for (let i = 0; i < 22; i++) {
        sum = sum + Number(this.myRateList[i]);
      }
      this.dataInfo.myTotal = sum;
      return sum;
    },
    ExpertSum(){
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum = sum + Number(this.expertRateList[i]);
      }
      this.dataInfo.expertTotal = sum;
      return sum;
    },
    citySum() {
      let sum = 0;
      for (let i = 0; i < 22; i++) {
        sum = sum + Number(this.cityRateList[i]);
      }
      this.dataInfo.cityTotal = sum;
      return sum;
    },
  },
  methods: {
    preview(i) {
      if (i == 1) {
        if (this.dataInfo.fileUrl1.indexOf("https")<0) {
          this.dataInfo.fileUrl1 = this.dataInfo.fileUrl1.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl1}`;
        window.open(url);
      }
      if (i == 2) {
        if (this.dataInfo.fileUrl2.indexOf("https")<0) {
          this.dataInfo.fileUrl2 = this.dataInfo.fileUrl2.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl2}`;
        window.open(url);
      }
      if (i == 3) {
        if (this.dataInfo.fileUrl3.indexOf("https")<0) {
          this.dataInfo.fileUrl3 = this.dataInfo.fileUrl3.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl3}`;
        window.open(url);
      }
      if (i == 4) {
        if (this.dataInfo.fileUrl4.indexOf("https")<0) {
          this.dataInfo.fileUrl4 = this.dataInfo.fileUrl4.replace(
            "http",
            "https"
          );
        }
        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl4}`;
        window.open(url);
      }
      if (i == 5) {
        if (this.dataInfo.fileUrl5.indexOf("https")<0) {
          this.dataInfo.fileUrl5 = this.dataInfo.fileUrl5.replace(
            "http",
            "https"
          );
        }

        let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${this.dataInfo.fileUrl5}`;
        window.open(url);
      }
    },
    // 返回上一页
    goBack() {
      sessionStorage.setItem("myRateList", JSON.stringify(this.myRateList));
      sessionStorage.setItem("cityRateList", JSON.stringify(this.cityRateList));
      sessionStorage.setItem("provincialRateList",JSON.stringify(this.provincialRateList));
      sessionStorage.setItem("expertRateList",JSON.stringify(this.expertRateList));
      this.$emit("openProjectTable");
    },
    // 提交按钮
    save(i) {
      // console.log(this.myRateList);
      // console.log(this.expertRateList);

      if (i == 1) {
        if (this.dataInfo.myTotal == "") {
          this.$message.warn("请打分");
          return;
        }
      }
      if(this.userTypeValue == 'expert'){
        this.expertEvaluationUpdate();
      }
      // alert('111')
      this.createdecInformation(i);
    },
    createdecInformation(i) {
      // let userId =JSON.parse(sessionStorage.getItem('userModel'))
      // // console.log(userId.id);
      // let expertCurrentValue = {};
      // expertCurrentValue.uid = userId.id;
      // expertCurrentValue.valueList = this.expertRateList;
      // let expertTotal = [];
      // expertTotal.push(expertCurrentValue)
      // console.log(expertTotal);
      
      // console.log(expertCurrentValue);
      this.newDataInfo.provincialRateList = this.provincialRateList;
      this.newDataInfo.cityRateList = this.cityRateList;
      this.newDataInfo.myRateList = this.myRateList;
      this.newDataInfo.expertRateList= this.expertRateList;
      let obj = JSON.parse(localStorage.getItem("userModel"));
      let params = {
        extraInfo: JSON.stringify(this.newDataInfo),
        type: 2,
        fromSource: obj.userType,
        status: i,
        decEntrance: this.newDataInfo.decEntrance,
        secondaryDecEntrance:obj.secondaryDecEntrance,
        expertEvaluation: this.dataInfo.expertTotal,
        unitName: this.newDataInfo.unitName,
        filePath: this.newDataInfo.fileUrl,
        selfEvaluation: this.dataInfo.myTotal,
        projectYear: "2023",
        toTarget: "cityAdm",
        linkMan: this.newDataInfo.contactPerson,
        linkPhone: this.newDataInfo.contactPhone,
        cityOpinion: "", //之前的市审核员审核意见要清空
        provinceOpinion: "", //之前的省审核员审核意见要清空
      };
      if (this.userTypeValue == "declarator") {
        params.toTarget = "cityAdm";
      } else if (this.userTypeValue == "cityAdm") {
        params.toTarget = "provinceAdm";
      } else if (this.userTypeValue == "expert") {
        params.toTarget = "provinceAdm";
        params.cityOpinion = this.newDataInfo.cityOpinion
        // params.selfEvaluation =this.dataInfo.expertTotal;
      }
      if (this.toTarget == "cityAdm") {
        params.cityOpinion = this.newDataInfo.cityOpinion;
        params.cityEvaluation = this.dataInfo.cityTotal;
        
      }
      if (
        this.dataInfo.decEntrance == "省属机关" ||
        this.dataInfo.decEntrance == "省属学会" ||
        this.dataInfo.decEntrance == "省属企业"
      ) {
        params.toTarget = "provinceAdm";
      }
      // 保存草稿
      // if (i == 0) {
      //   params.toTarget = "cityAdm";
      // }
      if (sessionStorage.getItem("declareInfo")) {
        let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
        params.id = declareInfoObj.id;
        if (this.userTypeValue == "cityAdm") {
          params.cityCheckUid = obj.productUserId;
        } else {
          params.cityCheckUid = 0;
        }
        if (this.toTarget != "cityAdm") {
          params.cityEvaluation = ""; //修改清除市评分
        }
        params.secondaryDecEntrance=declareInfoObj.secondaryDecEntrance
        if (params.decEntrance !== '部属、省属高校') {
          params.secondaryDecEntrance = ""
        }
        updateDecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        params.createUid = obj.productUserId;
        if (params.decEntrance !== '部属、省属高校') {
          params.secondaryDecEntrance = ""
        }
        createdecInformationApi(params).then((res) => {
          if (res.status) {
            this.$message.success(res.message);
            setTimeout(() => {
              this.$emit("backProject");
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    expertEvaluationUpdate(){
      let declareInfo = JSON.parse(sessionStorage.getItem('declareInfo'));
      let userModel = JSON.parse(sessionStorage.getItem('userModel'));
      console.log(this.expertRateList);
      // console.log(obj.id);
      let data ={
        id:declareInfo.checkRecordId,
        expertEvaluation:this.ExpertSum,
        expertEvaluationList: JSON.stringify(this.expertRateList),
      };
      decUserAccessUpdateApi(data).then((res)=>{
        console.log(res);
      })
    },
    
    saveFn() {
      console.log(this.provincialSum);
    },
    cancel() {
      this.$emit("goProject", this.chooseType);
    },
    restrictionFn(i, max, type) {
      // i 数组下标； max 最大值 ；type是哪个类型
      if (type == 0) {
        if (this.myRateList[i] <= 0) {
          this.myRateList[i] = 0;
        }
        if (this.myRateList[i] >= max) {
          this.myRateList[i] = String(max);
        }
        return;
      }
      if (type == 1) {
        if (this.cityRateList[i] <= 0) {
          this.cityRateList[i] = 0;
        }
        if (this.cityRateList[i] >= max) {
          this.cityRateList[i] = max;
        }
        return;
      }
      if (type == 2) {
        if (this.provincialRateList[i] <= 0) {
          this.provincialRateList[i] = 0;
        }
        if (this.provincialRateList[i] >= max) {
          this.provincialRateList[i] = max;
        }
        return;
      }
      if (type == 3) {
        if (this.expertRateList[i] <= 0) {
          this.expertRateList[i] = 0;
        }
        if (this.expertRateList[i] >= max) {
          this.expertRateList[i] = max;
        }
        return;
      }
    },
    uploaderCoverUrlOne() {},
    removeFile() {},
  },
  created() {
    if (localStorage.getItem("userModel")) {
      this.userTypeValue = JSON.parse(
        localStorage.getItem("userModel")
      ).userType;
    }
    if (sessionStorage.getItem("revewInfo")) {
      let revewInfoObj = JSON.parse(sessionStorage.getItem("revewInfo"));
      // this.newDataInfo=[...this.dataInfo,...revewInfoObj];
      // console.log(this.provincialRateList);
      this.newDataInfo.provincialRateList = this.provincialRateList;
      this.newDataInfo.cityRateList = this.cityRateList;
      this.newDataInfo.myRateList = this.myRateList;
      // this.newDataInfo.expertRateList = this.expertRateList;
      this.newDataInfo = Object.assign(this.dataInfo, revewInfoObj);
      // console.log(this.newDataInfo);
    }

    if (
      !sessionStorage.getItem("declareInfo") &&
      !sessionStorage.getItem("revewInfo")
    ) {
      this.saveStatus = 0;
      this.declareStatus = 0;
      this.myRateList = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      this.cityRateList = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      this.provincialRateList = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      this.expertRateList = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      this.dataInfo.fileName1 = "";
      this.dataInfo.fileName2 = "";
      this.dataInfo.fileName3 = "";
      this.dataInfo.fileName4 = "";
      this.dataInfo.fileName5 = "";
      this.dataInfo.fileUrl1 = "";
      this.dataInfo.fileUrl2 = "";
      this.dataInfo.fileUrl3 = "";
      this.dataInfo.fileUrl4 = "";
      this.dataInfo.fileUrl5 = "";
      this.dataInfo.myTotal = "";
      this.dataInfo.cityTotal = "";
      this.dataInfo.provincialTotal = "";
    }
    if (sessionStorage.getItem("declareInfo")) {
      let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));

      this.dataInfo.fileName1 = JSON.parse(declareInfoObj.extraInfo).fileName1;
      this.dataInfo.fileUrl1 = JSON.parse(declareInfoObj.extraInfo).fileUrl1;
      this.dataInfo.fileName2 = JSON.parse(declareInfoObj.extraInfo).fileName2;
      this.dataInfo.fileUrl2 = JSON.parse(declareInfoObj.extraInfo).fileUrl2;
      this.dataInfo.fileName3 = JSON.parse(declareInfoObj.extraInfo).fileName3;
      this.dataInfo.fileUrl3 = JSON.parse(declareInfoObj.extraInfo).fileUrl3;
      this.dataInfo.fileName4 = JSON.parse(declareInfoObj.extraInfo).fileName4;
      this.dataInfo.fileUrl4 = JSON.parse(declareInfoObj.extraInfo).fileUrl4;
      this.dataInfo.fileName5 = JSON.parse(declareInfoObj.extraInfo).fileName5;
      this.dataInfo.fileUrl5 = JSON.parse(declareInfoObj.extraInfo).fileUrl5;
      if (JSON.parse(declareInfoObj.extraInfo).myRateList) {
        this.myRateList = JSON.parse(declareInfoObj.extraInfo).myRateList;
      }
      if (JSON.parse(declareInfoObj.extraInfo).cityRateList) {
        this.cityRateList = JSON.parse(declareInfoObj.extraInfo).cityRateList;
      }
      if (JSON.parse(declareInfoObj.extraInfo).provincialRateList) {
        this.provincialRateList = JSON.parse(
          declareInfoObj.extraInfo
        ).provincialRateList;
      }
 
      
      // console.log(expertEvaluationString);

      if (this.userTypeValue == 'expert') {
        if (sessionStorage.getItem('expertEvaluationList')) {
          this.expertRateList =  JSON.parse(sessionStorage.getItem('expertEvaluationList'))
      }
      }

      this.dataInfo.myTotal = JSON.parse(declareInfoObj.extraInfo).myTotal;
      this.dataInfo.cityTotal = JSON.parse(declareInfoObj.extraInfo).cityTotal;
      this.dataInfo.expertTotal = JSON.parse(declareInfoObj.extraInfo).expertTotal;
      this.dataInfo.provincialTotal = JSON.parse(
        declareInfoObj.extraInfo
      ).provincialTotal;
      this.declareStatus = declareInfoObj.status;
      this.saveStatus = 1;
    }

    if (sessionStorage.getItem("revewInfo") && this.declareStatus == 2) {
      let revewInfoObj = JSON.parse(sessionStorage.getItem("revewInfo"));
      console.log(revewInfoObj);
      this.dataInfo.fileName1 = revewInfoObj.fileName1;
      this.dataInfo.fileUrl1 = revewInfoObj.fileUrl1;
      this.dataInfo.fileName2 = revewInfoObj.fileName2;
      this.dataInfo.fileUrl2 = revewInfoObj.fileUrl2;
      this.dataInfo.fileName3 = revewInfoObj.fileName3;
      this.dataInfo.fileUrl3 = revewInfoObj.fileUrl3;
      this.dataInfo.fileName4 = revewInfoObj.fileName4;
      this.dataInfo.fileUrl4 = revewInfoObj.fileUrl4;
      this.dataInfo.fileName5 = revewInfoObj.fileName5;
      this.dataInfo.fileUrl5 = revewInfoObj.fileUrl5;
    }
    if (sessionStorage.getItem("revewInfo") && this.declareStatus == 0) {
      let revewInfoObj = JSON.parse(sessionStorage.getItem("revewInfo"));
      console.log(revewInfoObj);
      this.dataInfo.fileName1 = revewInfoObj.fileName1;
      this.dataInfo.fileUrl1 = revewInfoObj.fileUrl1;
      this.dataInfo.fileName2 = revewInfoObj.fileName2;
      this.dataInfo.fileUrl2 = revewInfoObj.fileUrl2;
      this.dataInfo.fileName3 = revewInfoObj.fileName3;
      this.dataInfo.fileUrl3 = revewInfoObj.fileUrl3;
      this.dataInfo.fileName4 = revewInfoObj.fileName4;
      this.dataInfo.fileUrl4 = revewInfoObj.fileUrl4;
      this.dataInfo.fileName5 = revewInfoObj.fileName5;
      this.dataInfo.fileUrl5 = revewInfoObj.fileUrl5;
    }

    if (sessionStorage.getItem("myRateList")) {
      this.myRateList = JSON.parse(sessionStorage.getItem("myRateList"));
    }
    if (sessionStorage.getItem("cityRateList")) {
      this.cityRateList = JSON.parse(sessionStorage.getItem("cityRateList"));
    }
    // if (sessionStorage.getItem("expertRateList")) {
    //   this.expertRateList = JSON.parse(sessionStorage.getItem("expertRateList"));
    // }

    if (this.userTypeValue == 'expert') {
      if (this.ExpertSum> 0) {
        this.declareStatus = 4;
        this.saveStatus = 2;
      }else{
        this.declareStatus = 3;
      }
        
        if (sessionStorage.getItem('expertEvaluationList')) {
          this.expertRateList =  JSON.parse(sessionStorage.getItem('expertEvaluationList'))
      }
      }
    if (sessionStorage.getItem("provincialRateList")) {
      this.provincialRateList = JSON.parse(
        sessionStorage.getItem("provincialRateList")
      );
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
